import { s3PutResource } from './index';

export const updateS3 = async (url: string, file: File) => {
  await s3PutResource(url, file);
};
